import {notificationService} from '@jobseeker/feature-navigation/services';

import type {Dispatch} from 'react';
import type {AnyAction} from 'redux';
import type {NotificationReturnType} from '@jobseeker/feature-navigation/services/types';

const getNotificationCount = async (dispatch: Dispatch<AnyAction>) => {
  const notification: NotificationReturnType = await notificationService.count(
    'count'
  );

  if (!notification?.error?.code) {
    dispatch({
      type: 'AppContext/set_notification_count',
      payload: notification.count,
    });
    return notification?.count;
  } else {
    throw notification['error'];
  }
};

const getNotificationList = async (dispatch: Dispatch<AnyAction>) => {
  const notification = await notificationService.list('list');

  if (notification['list'] && notification['list'].length > 0) {
    dispatch({
      type: 'AppContext/set_notification_list',
      payload: notification.list,
    });
    return true;
  } else {
    throw notification['error'];
  }
};

const markNotificationRead = async (notificationId: number, type: number) => {
  await notificationService.markRead(`/read?id=${notificationId}&type=${type}`);
};

export {getNotificationCount, getNotificationList, markNotificationRead};
